/** Pozivni brojevi za izbor country koda uz telefon (registracija i sl.).
 *  Region prvo (eMeni tržište), zatim češće EU zemlje. Bez spoljne biblioteke —
 *  ngx-mat-intl-tel-input postoji samo u waiter/BO aplikacijama, a core dele i
 *  kiosk/KD/CD koji ga nemaju u zavisnostima. */
export interface ICallingCode {
  /** ISO 3166-1 alpha-2, npr. 'RS' */
  country: string;
  /** Pozivni broj sa plusom, npr. '+381' */
  dial: string;
  /** Emoji zastava (na Windows-u degradira u slova koda — čitljivo) */
  flag: string;
}

export const CALLING_CODES: readonly ICallingCode[] = [
  { country: 'RS', dial: '+381', flag: '🇷🇸' },
  { country: 'ME', dial: '+382', flag: '🇲🇪' },
  { country: 'BA', dial: '+387', flag: '🇧🇦' },
  { country: 'HR', dial: '+385', flag: '🇭🇷' },
  { country: 'SI', dial: '+386', flag: '🇸🇮' },
  { country: 'MK', dial: '+389', flag: '🇲🇰' },
  { country: 'AL', dial: '+355', flag: '🇦🇱' },
  { country: 'HU', dial: '+36', flag: '🇭🇺' },
  { country: 'RO', dial: '+40', flag: '🇷🇴' },
  { country: 'BG', dial: '+359', flag: '🇧🇬' },
  { country: 'GR', dial: '+30', flag: '🇬🇷' },
  { country: 'AT', dial: '+43', flag: '🇦🇹' },
  { country: 'DE', dial: '+49', flag: '🇩🇪' },
  { country: 'CH', dial: '+41', flag: '🇨🇭' },
  { country: 'IT', dial: '+39', flag: '🇮🇹' },
  { country: 'FR', dial: '+33', flag: '🇫🇷' },
  { country: 'NL', dial: '+31', flag: '🇳🇱' },
  { country: 'SE', dial: '+46', flag: '🇸🇪' },
  { country: 'NO', dial: '+47', flag: '🇳🇴' },
  { country: 'GB', dial: '+44', flag: '🇬🇧' },
  { country: 'US', dial: '+1', flag: '🇺🇸' },
];
